import { RouterProvider } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import router from "./router/Router";
import useWindowDimensions from "./utils/hooks/getWindowDimensions";

const App = () => {
  const { width } = useWindowDimensions();

  return (
    <div className="App">
      <ToastContainer
        limit={3}
        autoClose={4000}
        position={width < 600 ? "bottom-center" : "top-right"}
      />
      <RouterProvider router={router} />
    </div>
  );
};

export default App;
